import { BASE_ROUTE_PATH } from '@constants/page';

export const prependBasePath = (path: string): string => {
    if (path.startsWith(BASE_ROUTE_PATH)) {
        return path;
    }

    return `${BASE_ROUTE_PATH}${path}`;
};
